import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetSurveys(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}/surveys`);
    return res.json();
}

export async function apiCreateSurvey(groupId, question, groupIds) {
    const res = await fetch(`${API_URL}/groups/${groupId}/surveys`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({question, group_ids: groupIds || []})
    });
    return res.json();
}

export async function apiDeleteSurvey(surveyId) {
    const res = await fetch(`${API_URL}/surveys/${surveyId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}

export async function apiVote(surveyId, answer) {
    const res = await fetch(`${API_URL}/surveys/${surveyId}/vote`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({answer})
    });
    return res.json();
}

export async function apiGetResults(surveyId) {
    const res = await fetch(`${API_URL}/surveys/${surveyId}/results`, {
        headers: authHeaders()
    });
    return res.json();
}

export async function apiGetBackofficeSurveys(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}/surveys-backoffice`, {
        headers: authHeaders()
    });
    return res.json();
}
